var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.emojis),function(emoji,index){return _c('button',{key:`emoji-${index}`,staticClass:"btn btn-light p-2 emoji",on:{"click":function($event){return _vm.select(emoji)}}},[_vm._v(" "+_vm._s(emoji)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }